/** Shared corner radius for crisp, modern public marketing controls. */
export const PUBLIC_BTN_RADIUS = '8px';

/**
 * Primary actions on dark public pages — light fill, dark text (not flat blue).
 */
export const publicPrimaryButtonSx = {
  backgroundColor: '#f4f4f5',
  color: '#0c1222',
  borderRadius: PUBLIC_BTN_RADIUS,
  border: '1px solid rgba(255,255,255,0.14)',
  boxShadow: 'none',
  transition: 'background-color 0.2s ease, border-color 0.2s ease',
  '&:hover': {
    backgroundColor: '#fff',
    borderColor: 'rgba(255,255,255,0.28)',
    boxShadow: 'none',
    transform: 'none',
  },
  '&:active': {
    backgroundColor: '#e4e4e7',
  },
};

/** Outlined secondary on dark backgrounds. */
export const publicSecondaryButtonSx = {
  borderRadius: PUBLIC_BTN_RADIUS,
  borderColor: 'rgba(255,255,255,0.22)',
  color: 'rgba(255,255,255,0.9)',
  textTransform: 'none',
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    borderColor: 'rgba(255,255,255,0.38)',
    backgroundColor: 'rgba(255,255,255,0.05)',
  },
};

/** Inline text actions — no bright link blue. */
export const publicTextLinkSx = {
  px: 0,
  minWidth: 0,
  textTransform: 'none',
  color: 'rgba(255,255,255,0.82)',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: 'transparent',
    color: '#fff',
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
  },
};
